var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResellersicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Resellers_icon",
    "data-name": "Resellers icon",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_36967",
    x: 15.35,
    y: 17.366,
    width: 31.3,
    height: 28.268,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_464",
    "data-name": "Ellipse 464",
    cx: 31,
    cy: 31,
    r: 31,
    fill: "#56aa1c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_36967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36967-2",
    "data-name": "Path 36967",
    d: "M-172.63,371.871V397.05h15.239V371.871Zm6.334,18.7h-3.4v-3.4h3.4Zm0-5.859h-3.4v-3.4h3.4Zm0-5.859h-3.4v-3.4h3.4Zm5.882,11.718h-3.4v-3.4h3.4Zm0-5.859h-3.4v-3.4h3.4Zm0-5.859h-3.4v-3.4h3.4Zm16.085,4.876v13.406h-3.552v-7.07h-5.3v7.07h-3.552V383.733Zm0-2.469h-12.407v1.868h12.407Z",
    transform: "translate(189.48 -354)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellersicon);
export default __webpack_public_path__ + "static/media/Resellers icon.6eb6518b8852e9894113b76811400536.svg";
export { ForwardRef as ReactComponent };